'use client'

import Link from 'next/link'
import { Logo } from '@/components/logo'
import { MobileNav } from './mobile-nav'
import { NotificationBell } from './notification-bell'
import { ThemeToggle } from './theme-toggle'
import { UserMenu } from './user-menu'

export function Header() {
	return (
		<header className="sticky top-0 z-50 w-full border-b bg-background/95 backdrop-blur supports-[backdrop-filter]:bg-background/60">
			<div className="container mx-auto px-4">
				<div className="flex h-16 items-center justify-between">
					<div className="flex items-center gap-1">
						{/* Hamburger → cabinet nav drawer; only shows below md (no sidebar). */}
						<MobileNav />
						<div className="flex items-center space-x-2">
							<a
								href="https://extenshi.io"
								aria-label="Extenshi home"
								className="flex items-center space-x-2"
							>
								<Logo className="flex-shrink-0 text-primary" width={32} height={32} />
								<span className="hidden sm:inline text-xl font-bold text-foreground">extenshi.io</span>
							</a>
							<span className="text-xl font-light text-muted-foreground" aria-hidden="true">
								/
							</span>
							<Link
								href="/"
								className="rounded-md bg-primary/10 px-2 py-0.5 text-sm font-semibold text-primary transition-colors hover:bg-primary/20"
							>
								dojo
							</Link>
						</div>
					</div>
					<div className="flex shrink-0 items-center gap-1 sm:gap-4">
						<NotificationBell />
						<ThemeToggle />
						<UserMenu />
					</div>
				</div>
			</div>
		</header>
	)
}
